import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getAriaAttributes } from '../../../../util/getAriaAttributes/getAriaAttributes.js';
import { defaultIcons, agodaIcons } from '@ads/assets';
import { getAssetDataFromMetadata } from '../../utility/getAssetDataFromMetadata/getAssetDataFromMetadata.js';
import { getAssetDataFromTheme } from '../../utility/getAssetDataFromTheme/getAssetDataFromTheme.js';
import { getLocalSymbolAssetUrl, getRemoteAssetUrl } from '../../utility/getAssetUrl/getAssetUrl.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getDataFromTheme = function getDataFromTheme(id, context) {
  var storage = {
    default: defaultIcons,
    agoda: agodaIcons
  };
  return getAssetDataFromTheme(id, storage, context.theme);
};
var getDataFromExperiment = function getDataFromExperiment(experimentContainer) {
  var _experimentContainer$;
  return (// In IconV3 the v3 experiment is considered to always be true
    (_experimentContainer$ = experimentContainer.v3) !== null && _experimentContainer$ !== void 0 ? _experimentContainer$ : experimentContainer.default
  );
};
var getDataFromMetadata = function getDataFromMetadata(metadataContainer, context) {
  var localData = getAssetDataFromMetadata(metadataContainer, function (data) {
    return data.symbol;
  }, context);
  var remoteData = getAssetDataFromMetadata(metadataContainer, function (data) {
    return data.plain;
  }, context);
  return {
    localData: localData,
    remoteData: remoteData
  };
};
var combineDataToResult = function combineDataToResult(urlResult, dataResult) {
  return {
    url: urlResult.url,
    preloaded: urlResult.preloaded,
    flip: dataResult.flip
  };
};
var getIconData = function getIconData(id, context) {
  var experimentContainer = getDataFromTheme(id, context);
  if (experimentContainer === undefined) {
    // This should not happen according to our type system but may still happen if consumers provide icon ids by
    // casting them from string. We support them to some level by showing an error icon in that case
    return {
      url: '',
      preloaded: false,
      flip: false
    };
  }
  var metadataContainer = getDataFromExperiment(experimentContainer);
  var _getDataFromMetadata = getDataFromMetadata(metadataContainer, context),
    localData = _getDataFromMetadata.localData,
    remoteData = _getDataFromMetadata.remoteData;
  var localUrl = getLocalSymbolAssetUrl(localData.hash, context.localIcons);
  var remoteUrl = getRemoteAssetUrl(remoteData.hash, context.cdnUrl);
  return localUrl !== undefined ? combineDataToResult(localUrl, localData) : combineDataToResult(remoteUrl, remoteData);
};
var mapAriaAttributes = function mapAriaAttributes(props) {
  var _getAriaAttributes = getAriaAttributes(props),
    ariaAttributes = _getAriaAttributes.ariaAttributes,
    rest = _getAriaAttributes.rest;
  var usedProps = {};
  usedProps['aria-label'] = ariaAttributes['aria-label'];
  usedProps['aria-labelledby'] = ariaAttributes['aria-labelledby'];
  usedProps['aria-describedby'] = ariaAttributes['aria-describedby'];
  usedProps['aria-details'] = ariaAttributes['aria-details'];
  return {
    ariaAttributes: _objectSpread({
      'aria-hidden': Object.values(usedProps).every(function (value) {
        return value === undefined;
      }) ? true : undefined
    }, usedProps),
    rest: rest
  };
};

export { getIconData, mapAriaAttributes };
//# sourceMappingURL=Icon.helper.js.map
